module.exports = __webpack_public_path__ + "static/zeballos-6fa85e43f3353446f157335e2b0bd1ef.png";